module.exports = __webpack_public_path__ + "static/media/kin-logo.29aad688.svg";